module.exports = __webpack_public_path__ + "media/images/ui__arrowRightInactive--dark-9d14363cc68d1e1ece35381e7c52fcef.png";